export default __webpack_public_path__ + "static/media/86.6e45625b.svg";